module.exports = __webpack_public_path__ + "img/MenuButton_DB.0dccc099.png";